import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { HomeProject } from '@models/swagger';
import { ProjectUpdateNonModified, ProjectUpdateProject } from '@store/flow-data/project';
import { PostProjectFailure, PostProjectRequest, PostProjectSuccess } from './actions';
import { PostProjectService } from './service';

@Injectable()
export class PostProjectEffects {
  private readonly actions$ = inject(Actions);
  private readonly postProjectService = inject(PostProjectService);

  postProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PostProjectRequest),
      switchMap(({ body, parameters }) =>
        this.postProjectService.postProject(body, parameters).pipe(
          // NOTE: Set because post service is not returning it
          map(data => ({ ...data, projectStatusCode: HomeProject.ProjectStatusCodeEnum.Draft })),
          switchMap(data => [
            ProjectUpdateProject({ data }),
            ProjectUpdateNonModified({ data }),
            PostProjectSuccess({ data }),
          ]),
          catchError(error => of(PostProjectFailure({ error })))
        )
      )
    )
  );

}
